export default function animateHome(SVGs, injectorOptions) {
  SVGInjector(SVGs, injectorOptions, function(totalSVGsInjected) {

    //-- Cityscape animation
    var buildings = $('.anim-city #buildings').get(0),
    car1 = $('.anim-city #car1').get(0),
    car2 = $('.anim-city #car2').get(0),
    plane = $('.anim-city #plane1').get(0),
    csexxon = $('.anim-city #exxon').get(0),
    csamazon = $('.anim-city #amazon').get(0),
    csstripe = $('.anim-city #stripe').get(0),
    csqbooks = $('.anim-city #quickbooks').get(0),
    csshopify = $('.anim-city #shopify').get(0),
    // cstarget = $('.anim-city #target').get(0),
    cshdepot = $('.anim-city #homedepot').get(0),
    csairbnb = $('.anim-city #airbnb').get(0),
    csbestbuy = $('.anim-city #bestbuy').get(0),
    csxero = $('.anim-city #xero').get(0),
    cslowes = $('.anim-city #lowes').get(0),
    // csfedex = $('.anim-city #fedex').get(0),
    cswalmart = $('.anim-city #walmart').get(0),
    // csjetblue = $('.anim-city #jetblue').get(0),
    csdelta = $('.anim-city #delta').get(0),
    csalaska = $('.anim-city #alaska').get(0),
    csebay = $('.anim-city #ebay').get(0),
    csetsy = $('.anim-city #etsy').get(0),
    cspaypal = $('.anim-city #paypal').get(0),
    // cssquarespace = $('.anim-city #squarespace').get(0),
    csbigcartel = $('.anim-city #bigcartel').get(0),
    csjet = $('.anim-city #jet').get(0),
    csgoogle = $('.anim-city #google').get(0),
    // csbing = $('.anim-city #bing').get(0),
    csstarbucks = $('.anim-city #starbucks').get(0),
    cswoo = $('.anim-city #woo').get(0),
    csmenards = $('.anim-city #menards').get(0),
    csslack = $('.anim-city #slack').get(0),
    cssquare = $('.anim-city #square').get(0),
    csstaples = $('.anim-city #staples').get(0),
    cscvs = $('.anim-city #cvs').get(0),
    csmcdonalds = $('.anim-city #mcdonalds').get(0),
    csriteaid = $('.anim-city #riteaid').get(0),
    csverizon = $('.anim-city #verizon').get(0),
    csatt = $('.anim-city #att').get(0),
    csspirit = $('.anim-city #spirit').get(0),
    csnewegg = $('.anim-city #newegg').get(0),
    cswayfair = $('.anim-city #wayfair').get(0),
    csace = $('.anim-city #ace').get(0),
    csfacebook = $('.anim-city #facebook').get(0),
    // csapple = $('.anim-city #apple').get(0),
    // csautozone = $('.anim-city #autozone').get(0),
    csdominos = $('.anim-city #dominos').get(0);

    var logo1Anim = new TimelineMax({repeat: -1}),
        logo2Anim = new TimelineMax({repeat: -1}),
        logo3Anim = new TimelineMax({repeat: -1}),
        logo4Anim = new TimelineMax({repeat: -1}),
        logo5Anim = new TimelineMax({repeat: -1}),
        logo6Anim = new TimelineMax({repeat: -1}),
        logo7Anim = new TimelineMax({repeat: -1}),
        logo8Anim = new TimelineMax({repeat: -1}),
        logo9Anim = new TimelineMax({repeat: -1}),
        logo10Anim = new TimelineMax({repeat: -1}),
        logo11Anim = new TimelineMax({repeat: -1}),
        logo12Anim = new TimelineMax({repeat: -1}),
        logo13Anim = new TimelineMax({repeat: -1}),
        logo14Anim = new TimelineMax({repeat: -1}),
        cityCar1Anim = new TimelineMax({repeat: -1}),
        cityCar2Anim = new TimelineMax({repeat: -1}),
        cityPlaneAnim = new TimelineMax({repeat: -1});


    logo1Anim
      .set(csfacebook, {opacity: 0, transform: 'translateY(10px)'})
      .set(csmenards, {opacity: 0, transform: 'translateY(10px)'})

      // .to(csexxon, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 5 })
      .to(csmenards, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      .to(csmenards, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      .to(csfacebook, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      .to(csfacebook, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      // .to(csexxon, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })

    logo2Anim
      .set(csspirit, {opacity: 0, transform: 'translateY(10px)'})
      .set(cspaypal, {opacity: 0, transform: 'translateY(10px)'})

      .to(csamazon, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 1 })
      .to(csspirit, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      .to(csspirit, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      .to(cspaypal, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      .to(cspaypal, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      .to(csamazon, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })

    logo3Anim
      .set(csslack, {opacity: 0, transform: 'translateY(10px)'})
      .set(cscvs, {opacity: 0, transform: 'translateY(10px)'})

      .to(csstripe, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 4 })
      .to(csslack, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      .to(csslack, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      .to(cscvs, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      .to(cscvs, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      .to(csstripe, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })

    logo4Anim
      // .set(csatt, {opacity: 0, transform: 'translateY(10px)'})
      .set(csebay, {opacity: 0, transform: 'translateY(10px)'})

      .to(csqbooks, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 0.5 })
      // .to(csatt, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      // .to(csatt, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      .to(csebay, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      .to(csebay, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      .to(csqbooks, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })

    logo5Anim
      // .set(csbing, {opacity: 0, transform: 'translateY(10px)'})

      .to(csshopify, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 6 })
      /* .to(csalaska, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      .to(csalaska, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 }) */
      // .to(csbing, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      // .to(csbing, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      .to(csshopify, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })


    logo6Anim
      // .set(csace, {opacity: 0, transform: 'translateY(10px)'})
      .set(csbigcartel, {opacity: 0, transform: 'translateY(10px)'})

      // .to(cstarget, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 2 })
      .to(csbigcartel, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      .to(csbigcartel, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      // .to(csace, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      // .to(csace, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      // .to(cstarget, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })


    logo7Anim
      // .set(csmcdonalds, {opacity: 0, transform: 'translateY(10px)'})
      .set(cssquare, {opacity: 0, transform: 'translateY(10px)'})

      .to(cshdepot, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 1.4 })
      // .to(csmcdonalds, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      // .to(csmcdonalds, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      .to(cssquare, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      .to(cssquare, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      .to(cshdepot, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })


    logo8Anim
      .set(cswayfair, {opacity: 0, transform: 'translateY(10px)'})
      .set(csgoogle, {opacity: 0, transform: 'translateY(10px)'})

      .to(csairbnb, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 4 })
      .to(cswayfair, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      .to(cswayfair, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      .to(csgoogle, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      .to(csgoogle, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      .to(csairbnb, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })

    logo9Anim
      // .set(csapple, {opacity: 0, transform: 'translateY(10px)'})
      // .set(cswoo, {opacity: 0, transform: 'translateY(10px)'})

      .to(csbestbuy, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 6 })
      // .to(csapple, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      // .to(csapple, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      // .to(cswoo, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      // .to(cswoo, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      .to(csbestbuy, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })

    logo10Anim
      // .set(cssquarespace, {opacity: 0, transform: 'translateY(10px)'})
      // .set(csautozone, {opacity: 0, transform: 'translateY(10px)'})
      // .set(csstarbucks, {opacity: 0, transform: 'translateY(10px)'})

      .to(csxero, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 2.7 })
      // .to(cssquarespace, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      // .to(cssquarespace, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 5 })
      // .to(csautozone, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      // .to(csautozone, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      // .to(csstarbucks, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      // .to(csstarbucks, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      .to(csxero, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })

    logo11Anim
      .set(csetsy, {opacity: 0, transform: 'translateY(10px)'})

      .to(cslowes, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 1.4 })
      .to(csetsy, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      .to(csetsy, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      .to(cslowes, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })

    logo12Anim
      .set(csnewegg, {opacity: 0, transform: 'translateY(10px)'})
      .set(csjet, {opacity: 0, transform: 'translateY(10px)'})

      // .to(csfedex, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: .3 })
      .to(csnewegg, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      .to(csnewegg, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      .to(csjet, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      .to(csjet, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      // .to(csfedex, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })

    logo13Anim
      // .set(csverizon, {opacity: 0, transform: 'translateY(10px)'})
      .set(csstaples, {opacity: 0, transform: 'translateY(10px)'})

      .to(cswalmart, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      // .to(csverizon, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      // .to(csverizon, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      .to(csstaples, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      .to(csstaples, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      .to(cswalmart, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })

    logo14Anim
      // .set(csdominos, {opacity: 0, transform: 'translateY(10px)'})
      // .set(csriteaid, {opacity: 0, transform: 'translateY(10px)'})

      // .to(csjetblue, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 12 })
      // .to(csdominos, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      // .to(csdominos, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      // .to(csriteaid, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })
      // .to(csriteaid, .6, {opacity: 0, transform: 'translateY(10px)', ease: Power2.easeIn, delay: 8 })
      // .to(csjetblue, 1, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.2 })

    cityCar1Anim
      .to(car1, 25, {transform: 'translateX(1400px)', ease:Linear.easeNone})

    cityCar2Anim
      .to(car2, 16, {transform: 'translateX(-1450px)', ease:Linear.easeNone, delay: 6})

    cityPlaneAnim
      .set(csdelta, {opacity: 0})
      .set(plane, {opacity: 0})
      .to(plane, 12, {opacity: 0})
      .to(plane, 2, {opacity: 1})
      .to(plane, 15, {transform: 'translate(800px, -140px)', ease:Linear.easeNone, delay: -2})
      .to(plane, 0, {transform: 'translate(0, 0)', opacity: 0})
      .to(csalaska, 0.3, {opacity: 0})
      .to(csdelta, .3, {opacity: 1})
      .to(plane, 12, {opacity: 0})
      .to(plane, 2, {opacity: 1})
      .to(plane, 15, {transform: 'translate(800px, -140px)', ease:Linear.easeNone, delay: -2})
      .to(plane, 0, {transform: 'translate(0, 0)', opacity: 0})


    //-- Small Businesses animation
    var receipt1 = $('.anim-smb #rec1').get(0),
    receipt2 = $('.anim-smb #rec2').get(0),
    receipt3 = $('.anim-smb #rec3').get(0),
    receipt4 = $('.anim-smb #rec4').get(0),
    reclogo1 = $('.anim-smb #rec1logo').get(0),
    reclogo2 = $('.anim-smb #rec2logo').get(0),
    reclogo3 = $('.anim-smb #rec3logo').get(0),
    reclogo4 = $('.anim-smb #rec4logo').get(0),
    parsedrec = $('.anim-smb #parsedreceipt').get(0),
    logo1 = $('.anim-smb #logo1').get(0),
    logo2 = $('.anim-smb #logo2').get(0),
    logo3 = $('.anim-smb #logo3').get(0),
    logo4 = $('.anim-smb #logo4').get(0),
    output = $('.anim-smb #output').get(0),
    output1 = $('.anim-smb #sage').get(0),
    output2 = $('.anim-smb #xero').get(0),
    output3 = $('.anim-smb #quickbooks').get(0),
    arrow1 = $('.anim-smb #arrow1').get(0),
    arrow2 = $('.anim-smb #arrow2').get(0);

    var smbAnim = new TimelineMax({repeat: -1});

    smbAnim
      .set(arrow1, {opacity: 0, transform: 'translateY(-8px)'})
      .set(arrow2, {opacity: 0, transform: 'translateX(-8px)'})
      .set(output, {opacity: 0, scale: .6, transformOrigin:"center center"})
      .set(output1, {opacity: 0})
      .set(output2, {opacity: 0})
      .set(output3, {opacity: 0})
      .set(parsedrec, {opacity: 0, transform: 'translateY(-8px)'})
      .set(logo1, {opacity: 0, scale: .3, transformOrigin:"center center"})
      .set(logo2, {opacity: 0, scale: .3, transformOrigin:"center center"})
      .set(logo3, {opacity: 0, scale: .3, transformOrigin:"center center"})
      .set(logo4, {opacity: 0, scale: .3, transformOrigin:"center center"})

      .to(receipt4, 1.5, {transform: 'translateX(190px)', opacity: 0, ease: Power2.easeOut})
      .to(receipt3, 1.5, {transform: 'translateX(190px)', ease: Power2.easeOut, delay: -1.5})
      .to(receipt2, 1.5, {transform: 'translateX(190px)', ease: Power2.easeOut, delay: -1.5})
      .to(receipt1, 1.5, {transform: 'translateX(190px)', ease: Power2.easeOut, delay: -1.5})
      .to(reclogo2, .8, {opacity: 0, scale: .2, transformOrigin:"center center", ease: Power2.easeIn, delay: -1})
      .to(arrow1, .8, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut})
      .to(logo2, 1, {scale: 1, opacity: 1, ease: Power2.easeOut, delay: -.5})
      .to(parsedrec, .8, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.5})
      .to(arrow1, .4, {opacity: 0, transform: 'translateY(-8px)', ease: Power2.easeOut})
      .to(arrow2, .4, {opacity: 1, transform: 'translateX(0)', ease: Power2.easeOut})
      .to(output, .8, {opacity: 1, scale: 1, ease: Power3.easeOut, delay: -.8})
      .to(output2, .8, {opacity: 1, ease: Power3.easeOut, delay: -.2})
      .to(logo2, 1, {scale: .3, opacity: 0, ease: Power2.easeOut})
      .to(parsedrec, .4, {opacity: 0, transform: 'translateY(-8px)', ease: Power2.easeIn, delay: -.5})
      .to(arrow2, .4, {opacity: 0, transform: 'translateX(-8px)', ease: Power2.easeOut})
      .to(output2, .3, {opacity: 0, ease: Power3.easeIn, delay: -.5})
      .to(output, .4, {opacity: 0, scale: .6, ease: Power3.easeIn, delay: -.5})

      .to(receipt4, 0, {transform: 'translateX(-570px)', opacity: 0})
      .to(reclogo4, 0, {scale: 1, opacity: 1})
      .to(receipt4, 1.5, {transform: 'translateX(-410px)', opacity: 1, ease: Power2.easeOut})
      .to(receipt3, 1.5, {transform: 'translateX(360px)', ease: Power2.easeOut, opacity: 0, delay: -1.5})
      .to(receipt2, 1.5, {transform: 'translateX(360px)', ease: Power2.easeOut, delay: -1.5})
      .to(receipt1, 1.5, {transform: 'translateX(360px)', ease: Power2.easeOut, delay: -1.5})
      .to(reclogo1, .8, {opacity: 0, scale: .2, transformOrigin:"center center", ease: Power2.easeIn, delay: -1})
      .to(arrow1, .8, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut})
      .to(logo1, 1, {scale: 1, opacity: 1, ease: Power2.easeOut, delay: -.5})
      .to(parsedrec, .8, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.5})
      .to(arrow1, .4, {opacity: 0, transform: 'translateY(-8px)', ease: Power2.easeOut})
      .to(arrow2, .4, {opacity: 1, transform: 'translateX(0)', ease: Power2.easeOut})
      .to(output, .8, {opacity: 1, scale: 1, ease: Power3.easeOut, delay: -.8})
      .to(output2, .8, {opacity: 1, ease: Power3.easeOut, delay: -.2})
      .to(logo1, 1, {scale: .3, opacity: 0, ease: Power2.easeOut})
      .to(parsedrec, .4, {opacity: 0, transform: 'translateY(-8px)', ease: Power2.easeIn, delay: -.5})
      .to(arrow2, .4, {opacity: 0, transform: 'translateX(-8px)', ease: Power2.easeOut})
      .to(output2, .3, {opacity: 0, ease: Power3.easeIn, delay: -.5})
      .to(output, .4, {opacity: 0, scale: .6, ease: Power3.easeIn, delay: -.5})


      .to(receipt3, 0, {transform: 'translateX(-410px)', opacity: 0})
      .to(reclogo3, 0, {scale: 1, opacity: 1})
      .to(receipt3, 1.5, {transform: 'translateX(-240px)', opacity: 1, ease: Power2.easeOut})
      .to(receipt4, 1.5, {transform: 'translateX(-240px)', ease: Power2.easeOut, delay: -1.5})
      .to(receipt2, 1.5, {transform: 'translateX(550px)', opacity: 0, ease: Power2.easeOut, delay: -1.5})
      .to(receipt1, 1.5, {transform: 'translateX(550px)', ease: Power2.easeOut, delay: -1.5})
      .to(reclogo4, .8, {opacity: 0, scale: .2, transformOrigin:"center center", ease: Power2.easeIn, delay: -1})
      .to(arrow1, .8, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut})
      .to(logo4, 1, {scale: 1, opacity: 1, ease: Power2.easeOut, delay: -.5})
      .to(parsedrec, .8, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.5})
      .to(arrow1, .4, {opacity: 0, transform: 'translateY(-8px)', ease: Power2.easeOut})
      .to(arrow2, .4, {opacity: 1, transform: 'translateX(0)', ease: Power2.easeOut})
      .to(output, .8, {opacity: 1, scale: 1, ease: Power3.easeOut, delay: -.8})
      .to(output3, .8, {opacity: 1, ease: Power3.easeOut, delay: -.2})
      .to(logo4, 1, {scale: .3, opacity: 0, ease: Power2.easeOut})
      .to(parsedrec, .4, {opacity: 0, transform: 'translateY(-8px)', ease: Power2.easeIn, delay: -.5})
      .to(arrow2, .4, {opacity: 0, transform: 'translateX(-8px)', ease: Power2.easeOut})
      .to(output3, .3, {opacity: 0, ease: Power3.easeIn, delay: -.5})
      .to(output, .4, {opacity: 0, scale: .6, ease: Power3.easeIn, delay: -.5})


      .to(receipt2, 0, {transform: 'translateX(-240px)', opacity: 0})
      .to(reclogo2, 0, {scale: 1, opacity: 1})
      .to(receipt2, 1.5, {transform: 'translateX(-50px)', opacity: 1, ease: Power2.easeOut})
      .to(receipt3, 1.5, {transform: 'translateX(-50px)', ease: Power2.easeOut, delay: -1.5})
      .to(receipt4, 1.5, {transform: 'translateX(-50px)', ease: Power2.easeOut, delay: -1.5})
      .to(receipt1, 1.5, {transform: 'translateX(740px)', ease: Power2.easeOut, opacity: 0, delay: -1.5})
      .to(reclogo4, .8, {opacity: 0, scale: .2, transformOrigin:"center center", ease: Power2.easeIn, delay: -1})
      .to(arrow1, .8, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut})
      .to(logo4, 1, {scale: 1, opacity: 1, ease: Power2.easeOut, delay: -.5})
      .to(parsedrec, .8, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.5})
      .to(arrow1, .4, {opacity: 0, transform: 'translateY(-8px)', ease: Power2.easeOut})
      .to(arrow2, .4, {opacity: 1, transform: 'translateX(0)', ease: Power2.easeOut})
      .to(output, .8, {opacity: 1, scale: 1, ease: Power3.easeOut, delay: -.8})
      .to(output3, .8, {opacity: 1, ease: Power3.easeOut, delay: -.2})
      .to(logo4, 1, {scale: .3, opacity: 0, ease: Power2.easeOut})
      .to(parsedrec, .4, {opacity: 0, transform: 'translateY(-8px)', ease: Power2.easeIn, delay: -.5})
      .to(arrow2, .4, {opacity: 0, transform: 'translateX(-8px)', ease: Power2.easeOut})
      .to(output3, .3, {opacity: 0, ease: Power3.easeIn, delay: -.5})
      .to(output, .4, {opacity: 0, scale: .6, ease: Power3.easeIn, delay: -.5})


    //-- Enterprise animation
    var c1 = $('.anim-ent #c1').get(0),
    c2 = $('.anim-ent #c2').get(0),
    c3 = $('.anim-ent #c3').get(0),
    enarrow1 = $('.anim-ent #arrow1').get(0),
    enarrow2 = $('.anim-ent #arrow2').get(0),
    enarrow3 = $('.anim-ent #arrow3').get(0),
    enparsed = $('.anim-ent #parsedrec').get(0),
    enoutput = $('.anim-ent #output').get(0),
    enoutput2 = $('.anim-ent #sage').get(0),
    enoutput3 = $('.anim-ent #xero').get(0),
    enoutput4 = $('.anim-ent #quickbooks').get(0),
    enstripe = $('.anim-ent #stripe').get(0),
    enstripe2 = $('.anim-ent #stripe-short').get(0),
    enetsy = $('.anim-ent #etsy').get(0),
    enetsy2 = $('.anim-ent #etsy-short').get(0),
    enshopi = $('.anim-ent #shopify').get(0),
    enshopi2 = $('.anim-ent #shopify-short').get(0),
    enarrowout = $('.anim-ent #arrow4').get(0);

    var entAnim = new TimelineMax({repeat: -1}),
    gbAnim = new TimelineMax({repeat: -1});


    entAnim
      .set(c1, {opacity: 0, scale: .6, transformOrigin:"center center" })
      .set(c2, {opacity: 0, scale: .6, transformOrigin:"center center" })
      .set(c3, {opacity: 0, scale: .6, transformOrigin:"center center" })
      .set(enarrow1, {opacity: 0, transform: 'translate(-8px, -8px)'})
      .set(enarrow2, {opacity: 0, transform: 'translateX(-8px)'})
      .set(enarrow3, {opacity: 0, transform: 'translate(-8px, 8px)'})
      .set(enstripe, {opacity: 0})
      .set(enetsy, {opacity: 0})
      .set(enshopi, {opacity: 0})
      .set(enstripe2, {opacity: 0, scale: .5, transformOrigin:"center center"})
      .set(enetsy2, {opacity: 0, scale: .5, transformOrigin:"center center"})
      .set(enshopi2, {opacity: 0, scale: .5, transformOrigin:"center center"})
      .set(enparsed, {opacity: 0, transform: 'translateY(-12px)'})
      .set(enoutput, {opacity: 0, scale: .6, transformOrigin:"center center"})
      .set(enoutput2, {opacity: 0})
      .set(enoutput3, {opacity: 0})
      .set(enoutput4, {opacity: 0})
      .set(enarrowout, {opacity: 0, transform: 'translateX(-8px)'})

      .to(c1, 1, {scale: 1, opacity: 1, ease: Power3.easeOut, transformOrigin:"center center"})
      .to(enstripe, .8, {opacity: 1, delay: -.1})
      .to(enarrow1, .8, {opacity: 1, transform: 'translate(0, 0)', ease: Power3.easeOut })
      .to(enparsed, .8, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.5})
      .to(enstripe2, .8, {opacity: 1, scale: 1, ease: Power2.easeOut, delay: -.5})
      .to(enarrowout, .4, {opacity: 1, transform: 'translateX(0)', ease: Power2.easeOut, delay: -.4})
      .to(enoutput, .4, {opacity: 1, scale: 1, ease: Power3.easeOut, delay: -.1})
      .to(enoutput4, .3, {opacity: 1, ease: Power3.easeOut, delay: -.1})

      .to(enstripe, .6, {opacity: 0, delay: .5})
      .to(c1, .6, {scale: .6, opacity: 0, ease: Power3.easeOut, transformOrigin:"center center", delay: -.2})
      .to(enarrow1, .6, {opacity: 0, transform: 'translate(-8px, -8px)', ease: Power3.easeOut, delay: -.5 })
      .to(enstripe2, .6, {opacity: 0, scale: .5, ease: Power2.easeOut, delay: -.4})
      .to(enparsed, .6, {opacity: 0, transform: 'translateY(-8px)', ease: Power2.easeOut, delay: -.35})
      .to(enarrowout, .6, {opacity: 0, transform: 'translateX(-8px)', ease: Power2.easeOut, delay: -.5})
      .to(enoutput4, .6, {opacity: 0, ease: Power3.easeOut, delay: -.4})
      .to(enoutput, .6, {opacity: 0, scale: .5, ease: Power3.easeOut, delay: -.3})


      .to(c2, 1, {scale: 1, opacity: 1, ease: Power3.easeOut, transformOrigin:"center center", delay: -.5})
      .to(enetsy, .8, {opacity: 1, delay: -.1})
      .to(enarrow2, .8, {opacity: 1, transform: 'translate(0, 0)', ease: Power3.easeOut })
      .to(enparsed, .8, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.5})
      .to(enetsy2, .8, {opacity: 1, scale: 1, ease: Power2.easeOut, delay: -.5})
      .to(enarrowout, .4, {opacity: 1, transform: 'translateX(0)', ease: Power2.easeOut, delay: -.4})
      .to(enoutput, .4, {opacity: 1, scale: 1, ease: Power3.easeOut, delay: -.1})
      .to(enoutput3, .3, {opacity: 1, ease: Power3.easeOut, delay: -.1})

      .to(enetsy, .6, {opacity: 0, delay: .5})
      .to(c2, .6, {scale: .6, opacity: 0, ease: Power3.easeOut, transformOrigin:"center center", delay: -.2})
      .to(enarrow2, .6, {opacity: 0, transform: 'translate(-8px, -8px)', ease: Power3.easeOut, delay: -.5 })
      .to(enetsy2, .6, {opacity: 0, scale: .5, ease: Power2.easeOut, delay: -.4})
      .to(enparsed, .6, {opacity: 0, transform: 'translateY(-8px)', ease: Power2.easeOut, delay: -.35})
      .to(enarrowout, .6, {opacity: 0, transform: 'translateX(-8px)', ease: Power2.easeOut, delay: -.5})
      .to(enoutput3, .6, {opacity: 0, ease: Power3.easeOut, delay: -.4})
      .to(enoutput, .6, {opacity: 0, scale: .5, ease: Power3.easeOut, delay: -.3})


      .to(c3, 1, {scale: 1, opacity: 1, ease: Power3.easeOut, transformOrigin:"center center", delay: -.5})
      .to(enshopi, .8, {opacity: 1, delay: -.1})
      .to(enarrow3, .8, {opacity: 1, transform: 'translate(0, 0)', ease: Power3.easeOut })
      .to(enparsed, .8, {opacity: 1, transform: 'translateY(0)', ease: Power2.easeOut, delay: -.5})
      .to(enshopi2, .8, {opacity: 1, scale: 1, ease: Power2.easeOut, delay: -.5})
      .to(enarrowout, .4, {opacity: 1, transform: 'translateX(0)', ease: Power2.easeOut, delay: -.4})
      .to(enoutput, .4, {opacity: 1, scale: 1, ease: Power3.easeOut, delay: -.1})
      .to(enoutput3, .3, {opacity: 1, ease: Power3.easeOut, delay: -.1})

      .to(enshopi, .6, {opacity: 0, delay: .5})
      .to(c3, .6, {scale: .6, opacity: 0, ease: Power3.easeOut, transformOrigin:"center center", delay: -.2})
      .to(enarrow3, .6, {opacity: 0, transform: 'translate(-8px, -8px)', ease: Power3.easeOut, delay: -.5 })
      .to(enshopi2, .6, {opacity: 0, scale: .5, ease: Power2.easeOut, delay: -.4})
      .to(enparsed, .6, {opacity: 0, transform: 'translateY(-8px)', ease: Power2.easeOut, delay: -.35})
      .to(enarrowout, .6, {opacity: 0, transform: 'translateX(-8px)', ease: Power2.easeOut, delay: -.5})
      .to(enoutput3, .6, {opacity: 0, ease: Power3.easeOut, delay: -.4})
      .to(enoutput, .6, {opacity: 0, scale: .5, ease: Power3.easeOut, delay: -.3})

  });

}





